// @ts-nocheck


import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import notification from 'antd/lib/notification';


import { Tires as TiresComponents } from './../components';
import { resetVehicleStatus, setVehicleTires } from './../../../ducks/vehicle';
import { tireApi } from './../../../lib/api';

import { notificationLoading } from './../../../components/Notifications';


const { TiresForm, EditableItem } = TiresComponents;

















export class Tires extends Component {
  state = {
    availableTires: [],
    isLoading: false
  };

  async componentDidMount() {
    await this.fetchAvailableTires();
  }

  fetchAvailableTires = async (search) => {
    if (this.props.editable) {
      this.setState({
        isLoading: true
      });
      let availableTires = [];
      const result = await tireApi.fetchTires({
        search,
        page: 1,
        pageSize: 50,
        isFree: true,
        orgUnitId: this.props.employeeBranchOrgUnitId,
        nodeFilterType: 'branchAndChildren',
        isArchive: false
      });

      if (result) {
        availableTires = result.data;
      }
      this.setState({
        availableTires,
        isLoading: false
      });
    }
  };

  onAdd = async (tire) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      const updatedTire = await tireApi.updateTireVehicle({
        ...tire,
        vehicleId: this.props.vehicleId
      });
      await tireApi.fillReplaceDate({
        ...updatedTire
      });
      await this.props.resetVehicleStatus(this.props.vehicleId);
      await this.props.setVehicleTires(this.props.vehicleId);
      await this.fetchAvailableTires();
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err && err.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  onEdit = async (tire) => {
    await tireApi.updateTireVehicle(tire);
    await this.props.resetVehicleStatus(this.props.vehicleId);
    await this.props.setVehicleTires(this.props.vehicleId);
  };

  onRemove = async (tire) => {
    await tireApi.updateTire({ ...tire, vehicleId: null });
    await this.props.resetVehicleStatus(this.props.vehicleId);
    await this.props.setVehicleTires(this.props.vehicleId);
    await this.fetchAvailableTires();
  };

  handleSearch = debounce(
    async (value) => await this.fetchAvailableTires(value),
    500
  );

  render() {
    const {
      items = [],
      editable,
      canAddFuelMeasurement,
      vehicle
    } = this.props;
    const { availableTires, isLoading } = this.state;
    return (
      <>
        {items.map((item) => {
          if (!item) {
            return null;
          }
          return (
            <EditableItem
              key={item.id}
              tire={item}
              vehicle={vehicle}
              onChange={this.onEdit}
              onRemove={editable ? this.onRemove : null}
              editable={false} // TODO: нужны требования, но пока не можем редактировать шины в инвентарной карточке ТС
              canAddFuelMeasurement={canAddFuelMeasurement} />);


        })}
        {editable &&
        <TiresForm
          onSubmit={this.onAdd}
          vehicle={vehicle}
          handleSearch={this.handleSearch}
          fetchData={this.fetchAvailableTires}
          isLoading={isLoading}
          availableTires={availableTires} />

        }
      </>);

  }
}

export default connect(
  (state) => ({
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }),
  {
    resetVehicleStatus,
    setVehicleTires
  }
)(Tires);
